// extracted by mini-css-extract-plugin
export default {"wrapper":"NextStepBar_wrapper__0CDPi"};